import store from '.';
import { answerCall, endCall } from '../reducers/calls';
import { openPreferences, setActiveCustomerAndFetchLinkedUsers, } from '../reducers/client';
import { logout } from '../reducers/user';
export const initStoreListeners = () => {
    if (window.electronAPI && window.electronAPI.onSelectTeam) {
        window.electronAPI.onSelectTeam((teamId) => {
            store.dispatch(setActiveCustomerAndFetchLinkedUsers(teamId));
        });
        window.electronAPI.onLogOut(() => {
            store.dispatch(logout());
        });
        window.electronAPI.onPreferences(() => {
            store.dispatch(openPreferences());
        });
        window.electronAPI.onAnswerCall((callId) => {
            store.dispatch(answerCall(callId));
        });
        window.electronAPI.onHangUpCall((callId) => {
            store.dispatch(endCall(callId));
        });
    }
};
